module.exports = __webpack_public_path__ + "img/dingyuehao@2x.13c7bc22.png";